<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import {Link} from '@inertiajs/vue3';

const requireComponent = require.context("@/pages/inspection_reports/forms/", false, /\w+\.(vue|js)$/);
let components = {App, Card, Link};
for (let fileName of requireComponent.keys()) {
  let name = fileName.split("/").pop().split(".")[0];
  components[name] = requireComponent(fileName).default;
}

export default {
  components: components,
  data() {
    return {
      productLoaded: false,
      reportLoaded: false,
      responseLoaded: false,
      cylinderLoaded: false,
      customerProduct: {},
      cylinders: {},
      inspectionReport: {},
      inspectionReportResponse: {},
    }
  },
  props: [
    'appointmentId',
    'customerId',
    'customerProductId',
    'inspectionReportId',
  ],
  computed: {
    title() {
      if (!this.inspectionReport.name) {
        return 'Formulier';
      }
      return `${this.inspectionReport.name}`;
    },

    loaded() {
      return this.productLoaded && this.reportLoaded && this.responseLoaded && this.cylinderLoaded;
    }
  },

  mounted() {
    this.getCustomerProduct();
    this.getInspectionReport();
    this.getInspectionReportResponse();
    this.getCylinders();
  },

  methods: {
    getCustomerProduct() {
      $.ajax({
        url: route('api.v1.customers.products.show', {
          customer: this.customerId,
          customer_product: this.customerProductId
        }),
        success: (response) => {
          this.customerProduct = response.data;
        },
      }).always(() => {
        this.productLoaded = true;
      });
    },

    getInspectionReport() {
      $.ajax({
        url: route('api.v1.inspection_reports.show', {inspectionReport: this.inspectionReportId}),
        success: (response) => {
          this.inspectionReport = response.data;
        },
      }).always(() => {
        this.reportLoaded = true;
      });
    },

    getCylinders() {
      $.ajax({
        url: route('api.v1.cylinders.get_cylinders'),
        success: (response) => {
          this.cylinders = response.data;
        },
        error: (error) => {}
      }).always(() => {
        this.cylinderLoaded = true;
      });
    },

    async getInspectionReportResponse() {
      let create = false;
      let data = {
        appointment_id: this.appointmentId,
        inspection_report_id: this.inspectionReportId,
        customer_product_id: this.customerProductId,
      };

      await $.ajax({
        url: route('api.v1.inspection_report_responses.show'),
        data: data,
        success: (response) => {
          this.inspectionReportResponse = response.data;
        },
        error: (error) => {
          if (error.status == 404) {
            create = true;
            return;
          }
          Helpers.Message.error(error.responseJSON.message);
        }
      }).catch(() => {
      });

      if (create) {
        await $.ajax({
          url: route('api.v1.inspection_report_responses.create'),
          data: data,
          method: 'POST',
          success: (response) => {
            this.inspectionReportResponse = response.data;
          }
        });
      }

      this.responseLoaded = true;
    }
  }
}
</script>

<template>
  <App :title="title">

    <h2>Form {{ inspectionReport.id}}</h2>

    <component
        v-if="loaded"
        :is="`form_${inspectionReport.id}`"
        :inspectionReport="inspectionReport"
        :inspectionReportResponse="inspectionReportResponse"
        :customerProduct="customerProduct"
        :appointmentId="appointmentId"
        :cylinders="cylinders"
    />

    <template #bottomButtons>
      <div class="d-flex gap-2">
        <Link :href="route('inspection_reports.index', {appointment: this.appointmentId})" class="btn btn-secondary">Terug naar overzicht</Link>

        <button form="inspection_form" class="btn btn-primary" :class="{'loading' : !loaded}" :disabled="!loaded">
          Formulier afronden
        </button>
      </div>
    </template>
  </App>
</template>